<template>
  <div class="vuse-content-wrapper">
    <vuse-section-definition
        :breadcrumbs="breadcrumbs"
        :title="page"
        icon="mdi-image-filter-black-white"
    ></vuse-section-definition>
    <v-container fluid>
      <v-row class="mx-1 mt-2">
        <v-col cols="12">
          <v-btn color="primary" @click="back">
            BACK
          </v-btn>
        </v-col>
        <v-col cols="10" class="white p-5 ">

          <v-col cols="12">
            <div class="mb-2">Name<span class="necessary">(*)</span></div>
            <v-row>
              <v-col cols="9">
                <v-text-field
                    placeholder="Enter the name of the image"
                    filled
                    v-model="templateDetail.name"
                ></v-text-field>
              </v-col>
              <v-col cols="3">
                <v-checkbox label="Free" v-model="templateDetail.free">
                </v-checkbox>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12">
            <div class="mb-2">Themes</div>
            <v-select
                v-model="list_theme_id"
                :items="listThemes"
                item-text="name"
                item-value="id"
                filled
                placeholder="Choose the theme of the template"
                chips
                multiple
            ></v-select>
          </v-col>
          <v-col cols="12">
            <div class="mb-2">Tags</div>
            <v-select
                v-model="list_tags_id"
                :items="list_tags"
                item-text="name"
                item-value="id"
                filled
                placeholder="Choose the tag of the template"
                chips
                multiple
            ></v-select>
          </v-col>
          <v-col cols="12">
            <v-row class="d-flex ml-2 align-center mb-2">
              <div class="text-decoration-underline" style="color: #585858; font-size: 18px">Upload
                Design
              </div>
              <v-btn class="ml-3 white--text" color="#71BEC8" @click="addField">Add</v-btn>
            </v-row>
            <div v-for="(item, index) in upload_designs" :key="index">
              <v-row class="mt-8" width="100%">
                <v-col cols="3">
                  <div class="mb-2">Size<span class="necessary">(*)</span></div>
                  <v-select
                      v-model="item.template_size_id"
                      :items="listTemplateSize"
                      item-text="name"
                      item-value="id"
                      placeholder="Choose the size"
                      filled
                      chips
                  ></v-select>
                </v-col>
                <v-col cols="3">
                  <div class="mb-2">Type</div>
                  <v-select
                      v-model="item.template_types"
                      :items="listTemplateType"
                      item-text="name"
                      item-value="id"
                      placeholder="Choose the type"
                      filled
                      chips
                      multiple
                  ></v-select>
                </v-col>

                <v-col cols="5">
                  <div class="mb-2">Photoshop file</div>
                  <div class="drag-drop">
                    <div v-if="!item.img_url" class="drag-drop-gird">
                      <div v-if="!item.loading"
                           :class="['dropZone', item.dragging ? 'dropZone-over' : '']"
                           @dragenter="item.dragging = true"
                           @dragleave="item.dragging = false">
                        <div class="dropZone-info" @drag="onChange">
                          <div>
                            <v-icon class="icon" large>mdi-cloud-upload-outline</v-icon>
                          </div>
                          <span class="dropZone-title">DROP YOUR PHOTOSHOP FILE HERE</span>
                          <div class="dropZone-upload-limit-info">
                            <div>Or <span style="color:#71BEC8 ">load</span> from computer
                            </div>
                          </div>
                        </div>

                        <input type="file" ref="fileUpload"
                               @change="onChange($event,item.template_size_id)">
                      </div>
                      <div v-else class="loading">
                        <v-progress-circular
                            indeterminate
                            color="primary"
                        ></v-progress-circular>
                      </div>
                    </div>
                    <div v-else class="dropZone-uploaded">
                      <div class="dropZone-uploaded-info">
                        <span class="file-name_text "
                              v-if="item.img_url?.name">{{ item.img_url.name }} </span>
                        <img :src="item.img_url" width="100" height="100" v-else
                             class="mb-2">
                        <button
                            class="btn-remove"
                            @click="removeFile(item.template_size_id)">Remove File
                        </button>
                      </div>
                    </div>
                  </div>
                </v-col>
                <v-col cols="1">
                  <div class="mb-7"></div>
                  <v-btn class="btn-recycle rounded-lg" height="58" @click="clearBlock(item)">
                    <v-icon>mdi-delete</v-icon>
                  </v-btn>
                  <v-btn class="mt-2 rounded-lg" style="background-color: black; color:white" height="45"
                         @click="editBlock(item)" v-if="item.json_template_file">
                    Save
                  </v-btn>
                </v-col>
              </v-row>
            </div>
          </v-col>

          <v-col cols="12" class="text-center mb-5 mt-1">
            <v-btn
                class="btn-add-templates"
                @click="editTemplate"
            >
              SAVE
            </v-btn>
          </v-col>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import {GET_LIST_TEMPLATE_SIZE} from "@/store/modules/template_size";
import {DELETE_FILE_PSD, GET_DETAIL_TEMPLATE, UPDATE_TEMPLATE, UPLOAD_DESIGN_TEMPLATE} from "@/store/modules/template";
import {GET_LIST_TEMPLATE_THEMES} from "@/store/modules/themes";
import {GET_LIST_TAGS} from "@/store/modules/tags";
import {onChildChanged, ref} from "firebase/database";
import {db} from "@/config/firebase";
import Vue from "vue";
import {GET_LIST_TEMPLATE_TYPE} from "../../../store/modules/template_type";
import {EDIT_DESIGN_TEMPLATE} from "../../../store/modules/template";

export default {
  name: "AddTemplate",
  setup() {
    async function getFireBaseStatus() {
      const starCountRef = ref(db, 'app_editor');
      onChildChanged(starCountRef, (dataFireBase) => {
        setFireBaseValues(dataFireBase.key);
      });

      function setFireBaseValues(dataFireBase) {
        const data = dataFireBase;

        if (data !== null) {
          Vue.toasted.success('Update Json template ' + data + ' successful!', {
            duration: 3000,
            position: 'top-right'
          })
        }
      }
    }

    getFireBaseStatus();
  },

  data() {
    return {
      page: "Templates",
      breadcrumbs: [
        {
          text: "Templates Setting",
          disabled: true,
        },
        {
          text: "Templates",
          disabled: false,
          href: '/template_setting/templates',
        },
        {
          text: "Edit Template",
          disabled: false,
        },
      ],
      upload_designs: [],
      list_theme: [],
      list_theme_id: [],
      list_tags: [],
      list_tags_id: [],
    }
  },
  computed: {
    ...mapGetters({
      templateDetail: "templateDetail",
      listTemplateSize: "listTemplateSize",
      listThemes: "listThemes",
      tags: "tags",
      listTemplateType: "listTemplateType",
    })
  },
  async created() {
    await this.$store.dispatch(GET_LIST_TEMPLATE_THEMES);
    await this.$store.dispatch(`${GET_DETAIL_TEMPLATE}`, this.$route.params.id);
    await this.$store.dispatch(GET_LIST_TEMPLATE_SIZE);
    await this.$store.dispatch(GET_LIST_TAGS);
    await this.$store.dispatch(GET_LIST_TEMPLATE_TYPE);
    if (this.templateDetail && this.templateDetail.template_template_sizes) {
      this.templateDetail.template_template_sizes.forEach((el) => {
        this.upload_designs.push(el)
      });
    }
    if (this.templateDetail && this.templateDetail.size) {
      this.templateDetail.size.forEach((el) => {
        this.list_size_id.push(el.pivot.tag_id);
      });
    }
    if (this.templateDetail && this.templateDetail.theme) {
      this.templateDetail.theme.forEach((el) => {
        this.list_theme_id.push(el.pivot.tag_id);
      });
    }
    if (this.templateDetail && this.templateDetail.tags) {
      this.templateDetail.tags.forEach((el) => {
        this.list_tags_id.push(el.pivot.tag_id);
      });
    }
  },
  watch: {
    listThemes(val) {
      if (val) {
        const _this = this
        val.forEach(el => {
          _this.list_theme.push({
            id: el.id,
            name: el.name,
          })
        })
      }
    }, tags(val) {
      if (val) {
        const _this = this
        val.forEach(el => {
          _this.list_tags.push({
            id: el.id,
            name: el.name,
          })
        })
      }
    },
  },
  methods: {
    addField() {
      this.upload_designs.push({
        id: this.getMaxId(),
        template_size_id: '',
        template_types: [],
        img_url: '',
        loading: false,
        dragging: false,
        note: '90'

      })
    },
    clearBlock(item) {
      if (item && item.template_id && item.template_size_id) {
        let payload = {
          template_id: item.template_id,
          template_size_id: item.template_size_id
        }
        this.$store.dispatch(`${DELETE_FILE_PSD}`, payload).then((data) => {
          if (data && data.status == 1) {
            this.$toasted.success('Delete successful!', {
              duration: 1000,
              position: 'top-center'
            })
            this.upload_designs = this.upload_designs.filter(el => el.id !== item.id)
          }
        })
      } else {
        this.upload_designs = this.upload_designs.filter(el => el.id !== item.id)
      }
    },
    editBlock(item) {
      let payload = {
        template_id: item.id,
        data: {
          template_size_id: item.template_size_id,
          templateTypeIds: item.template_types,
        }
      }
      this.$store.dispatch(`${EDIT_DESIGN_TEMPLATE}`, payload).then((data) => {
        if (data && data.data && data.data.status == 1) {
          this.$toasted.success('Edit successful!', {
            duration: 1000,
            position: 'top-center'
          })
        }
      })
    },
    getMaxId() {
      const ids = []
      if (this.upload_designs && this.upload_designs.length > 0) {
        this.upload_designs.forEach(object => {
          ids.push(object.id)
        });
        if (ids) return Math.max(...ids) + 1;
        return 0
      }
      return 0
    },

    onChange(e, size_id) {
      let count = 0
      for (const item of this.upload_designs) {
        if (item.template_size_id == size_id) {
          count++
        }
      }
      if (count == 1) {
        for (const item of this.upload_designs) {
          if (item.template_size_id === size_id) {
            if (item.template_size_id == '') {
              this.$toasted.error('Choose the size of the template!', {
                duration: 3000,
                position: 'top-center'
              })
              const fileInput = e.target
              fileInput.value = null
              fileInput.files = null
              return false
            } else {
              item.loading = true
              this.$forceUpdate()
              let files = e.target.files || e.dataTransfer.files;
              if (!files.length) {
                item.dragging = false;
                continue;
              }
              if (files[0]) {
                let form = new FormData();
                form.append("upload", files[0]);
                form.append("id", this.$route.params.id);
                form.append("template_size_id", item.template_size_id);
                form.append("templateTypeIds", JSON.stringify(item.template_types));
                this.$store.dispatch(`${UPLOAD_DESIGN_TEMPLATE}`, form).then((data) => {
                  if (data.data.status == 1) {
                    item.img_url = files[0];
                    item.dragging = false;
                    item.loading = false
                  } else {
                    alert(data.data.errors)
                  }
                })
              }
            }

          }
        }
      } else {
        this.$toasted.error('Choose other size of the template!', {
          duration: 3000,
          position: 'top-center'
        })
        const fileInput = e.target
        fileInput.value = null
        fileInput.files = null
        return false
      }

    },
    removeFile(id) {
      this.upload_designs.forEach(item => {
        if (item.template_size_id === id) {
          item.img_url = '';
          item.loading = false
        }
      })
    },

    async editTemplate() {
      this.templateDetail.theme = []
      this.templateDetail.tags = []
      const _this = this;
      //list tags

      this.list_theme_id.forEach(id => {
        let tag = _this.list_theme.find(el => el.id == id)
        _this.templateDetail.theme.push(
            tag.id
        )
      })
      this.list_tags_id.forEach(id => {
        let tag = _this.list_tags.find(el => el.id == id)
        _this.templateDetail.tags.push(
            tag.id
        )
      })
      let form = {
        "name": this.templateDetail.name,
        "free": this.templateDetail.free,
        "theme": JSON.stringify(this.templateDetail.theme),
        "tags": JSON.stringify(this.templateDetail.tags)
      }
      let data = {
        id: this.$route.params.id,
        payload: form
      }
      await this.$store.dispatch(`${UPDATE_TEMPLATE}`, data).then((data) => {
        if (data.data.status == 1) {
          this.$toasted.success('Update successful!', {
            duration: 1000,
            position: 'top-center'
          })
          this.back()
        } else {
          alert(data.data.errors)
        }
      });
    },
    back() {
      window.history.go(-1)
    }
  }
}
</script>

<style scoped>
.necessary {
  color: red;
}

.btn-add-templates {
  background-color: #71BEC8 !important;
  color: white !important;
  border-radius: 36px !important;
}

.drag-drop {
  border: 0.5px dashed #949494;
  border-radius: 6px;
  height: 200px;
  width: 100%;
  position: relative;
}

.icon {
  color: #71BEC8;
}

.drag-drop-gird {
  width: 100%;
  height: 100%
}

.dropZone {
  width: 100%;
  height: 100%;
  position: relative;
}

.dropZone-info {
  color: #696969;
  position: absolute;
  top: 50%;
  width: 100%;
  transform: translate(0, -50%);
  text-align: center;
  padding: 5px;
}

.dropZone-title {
  color: #71BEC8;
}

.dropZone input {
  position: absolute;
  cursor: pointer;
  top: 0px;
  right: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
}

.dropZone-upload-limit-info {
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
}


.dropZone-uploaded {
  width: 100%;
  height: 100%;
  position: relative;
}

.dropZone-uploaded-info {
  display: flex;
  flex-direction: column;
  align-items: center;
  position: absolute;
  top: 50%;
  width: 100%;
  transform: translate(0, -50%);
  text-align: center;
}

.btn-add-templates {
  background-color: #71BEC8 !important;
  color: white !important;
  border-radius: 36px !important;
}

.loading {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.file-name_text {
  font-size: 16px;

  font-weight: 500;
}

.btn-remove {
  border: 1px solid #71BEC8;
  border-radius: 6px;
  padding: 5px 10px;
}

.btn-remove:hover {
  color: white;
  background-color: #71BEC8;
  border-color: #71BEC8;
}
</style>